import React, { useState } from 'react'
import Button from 'components/shared/Button'
import { InputField, DropdownField } from 'components/forms/reduxForm'
import { statesOptions } from 'constants/constantVariables'
import strings from 'strings'
import AuthService from "../../../../tools/AuthService";
import { FormControlLabel, Checkbox } from "@material-ui/core";
import styles from 'components/forms/Checkbox/Checkbox.module.scss';
import CreditCost from 'components/shared/CreditCost'

const SosSearchFields = (props) => {

    const { loading, handleSosSearch, isQuickSearch, creditCosts } = props
    const { creditUsageEnabled } = AuthService.getClientFeatures()

    // form data
    const [businessName, setBusinessName] = useState('')
    const [state, setState] = useState('')
    const [relatedBusinesses, setRelatedBusinesses] = useState(false)

    function getEndIcon() {
        if (creditCosts){
            const costObj = creditCosts.find(cost => cost.requestType === 'SOS_SEARCH');
            return costObj ? costObj.creditCost : 0;
        }
        return 0;
    }

    return (
        <div className='sosFieldContainer'>
            <div className='d-flex'>
                <InputField
                    name='businessName'
                    label='Business Name'
                    required
                    id='businessNameSos'
                    onChange={(e) => setBusinessName(e.target.value)}
                />
            </div>
            <div className='d-flex'>
                <DropdownField
                    name={'state'}
                    label='Select State'
                    options={statesOptions.USA}
                    required
                    isSearchable
                    onChange={(e) => setState(e)}
                    id='stateSos'
                />
            </div>
            <div className='d-flex align-items-center justify-content-between' style={{ gap: '16px' }}>
                <FormControlLabel
                    className={styles.centeredCheckbox}
                    control={
                        <Checkbox
                            id='relatedBusinessesCheckbox'
                            checked={relatedBusinesses}
                            onChange={(e) => setRelatedBusinesses(e.target.checked)}
                            color="primary"
                        />
                    }
                    label="Include Related Businesses"
                />
                <Button
                    onClick={() => handleSosSearch({ businessName, state, relatedBusinesses })}
                    loading={loading}
                    id={`perform-sos-search-${isQuickSearch ? 'qs' : 'app'}`}
                    disabled={!state || !businessName}
                    style={{ whiteSpace: 'nowrap', flexShrink: 0 }}
                    endIcon={creditUsageEnabled && creditCosts ?
                        <CreditCost cost={getEndIcon()} /> : undefined}
                >
                    {strings.SEARCH}
                </Button>
            </div>
        </div>
    )
}

export default SosSearchFields